import { Stack, Box, FormControlLabel } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import React from "react";

import { language } from "../../../../language";
import { getUniqueDocumentServiceFields } from "../../../../util/camundaPropertiesPanelUtils";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { getDocumentoVariables } from "../helper";

export default class DocumentViewer {
  static DisplayTab(props) {
    const { onChange, state, classes } = props;

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            fullWidth
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="id"
            value={state.id || ""}
          />
        </Grid>

        <Grid size={12}>
          <Tooltip title={language.toolTipDescription} placement="right">
            <TextField
              fullWidth
              onChange={(event) => onChange(event)}
              name="description"
              variant="outlined"
              id="description"
              label={language.propertieDescription}
              value={state.description || ""}
            />
          </Tooltip>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      state,
      classes,
      handleMultiSelectChange,
      lines,
      allFormFields,
      businessObject,
    } = props;

    const documentsToSign = getUnitPropertie(state, "documentsToView");
    const downloadZip = getUnitPropertie(state, "downloadZip");

    let uniqueFields = allFormFields || [];

    let exitentFields = lines || [];

    exitentFields = exitentFields.filter((value) => {
      return uniqueFields.findIndex((obj) => obj.id === value.id) === -1;
    });

    uniqueFields = uniqueFields.concat(exitentFields);

    let documentoVariables = getDocumentoVariables(uniqueFields);

    if (businessObject) {
      documentoVariables = documentoVariables.concat(
        getUniqueDocumentServiceFields(businessObject),
      );
    }

    const isChecked = downloadZip === true || downloadZip === "true";

    const handleToggle = () => {
      handleMultiSelectChange(!isChecked, "downloadZip");
    };

    return (
      <Grid container spacing={2}>
        <FormControl fullWidth variant="outlined">
          <Autocomplete
            value={documentsToSign || []}
            onChange={(event, newValues) => {
              handleMultiSelectChange(newValues, "documentsToView");
            }}
            multiple
            id="documentsToView"
            options={documentoVariables || []}
            getOptionLabel={(fileField) => fileField.id}
            filterSelectedOptions
            disableCloseOnSelect
            getOptionSelected={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label={language.documentsToView}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <Stack
            spacing={2}
            direction="row"
            useFlexGap
            justifyContent="center"
            sx={{ flexWrap: "wrap" }}
          >
            <Box
              key="downloadZip"
              role={undefined}
              dense
              button
              onClick={handleToggle}
            >
              <FormControlLabel
                label={language.allowDownloadZip}
                control={
                  <Checkbox
                    edge="start"
                    checked={isChecked}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{
                      "aria-labelledby": "checkbox-download-zip",
                    }}
                  />
                }
              />
            </Box>
          </Stack>
        </FormControl>
      </Grid>
    );
  }
}
